import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const PRIORITY_CODES = [
  { code: "rosso", label: "Rosso", classes: "bg-red-600 text-white border-red-700" },
  { code: "arancione", label: "Arancione", classes: "bg-orange-500 text-white border-orange-600" },
  { code: "azzurro", label: "Azzurro", classes: "bg-sky-500 text-white border-sky-600" },
  { code: "verde", label: "Verde", classes: "bg-emerald-500 text-white border-emerald-600" },
  { code: "bianco", label: "Bianco", classes: "bg-white text-slate-900 border-2 border-slate-300" },
];

export const codeClasses = (code) => {
  const found = PRIORITY_CODES.find((c) => c.code === code);
  return found ? found.classes : "bg-slate-200 text-slate-600 border-slate-300";
};
